import {SET_ORDER, SET_ORDER_BY, SET_PAGE, SET_ROWS_PER_PAGE} from "../reducers/actions/ActionTypes";

export function setPage(page, dispatch){
	dispatch({type: SET_PAGE, payload: page});
}

export function setRowsPerPage(rowsPerPage, dispatch){
	dispatch({type: SET_ROWS_PER_PAGE, payload: rowsPerPage});
}

export function setOrder(order, dispatch){
	dispatch({type: SET_ORDER, payload: order});
}

export function setOrderBy(orderBy, dispatch){
	dispatch({type: SET_ORDER_BY, payload: orderBy});
}